import Vue from 'vue';
import { operateClass } from '@tencent/qd-lib';
function createDialogContianer() {
    const div = document.createElement('div');
    document.body.appendChild(div);
    return div;
}

function removeDialog(dialog) {
    dialog.$destroy();

    if (dialog.$el && dialog.$el.parentNode) {
        dialog.$el.parentNode.removeChild(dialog.$el);
    }
}

export function showDialog(options) {
    const container = createDialogContianer();
    const dialog = new Vue({
        el: container,
        data() {
            return {
                confirmLoading: false
            };
        },
        render(createElement) {
            const confirmHandle = e => {
                if (typeof options.confirm === 'function') {
                    options.confirm(e);
                }

                if (!e.defaultPrevented) {
                    removeDialog(dialog);
                }
            };

            let titleRender = '';
            let contentRender = '';
            let footerRender = '';

            if (options.titleRender) {
                titleRender = createElement('div', { slot: 'title' }, [options.titleRender(createElement)]);
            }

            if (options.render) {
                contentRender = options.render(createElement);
            } else if (options.content) {
                contentRender = createElement('div', { domProps: { innerHTML: options.content } });
            }

            if (options.footerRender) {
                footerRender = createElement('div', { slot: 'footer' }, [options.footerRender(createElement)]);
            } else if (options.onlyConfirmBtn) {
                footerRender = createElement('div', { slot: 'footer' }, [
                    <v-button status="primary" size="large" onClick={confirmHandle}>
                        {options.confirmText || '确定'}
                    </v-button>
                ]);
            }

            return createElement(
                'v-dialog',
                {
                    ref: 'dialog',
                    props: {
                        open: true,
                        kind: 'confirm',
                        status: options.status || 'primary',
                        title: options.title,
                        confirmLoading: this.confirmLoading
                    },
                    on: {
                        confirm: confirmHandle,
                        cancel(e) {
                            if (typeof options.cancel === 'function') {
                                options.cancel(e);
                            }

                            if (!e.defaultPrevented) {
                                removeDialog(dialog);
                            }
                        },
                        close(e) {
                            if (typeof options.close === 'function') {
                                options.close(e);
                            }

                            if (!e.defaultPrevented) {
                                removeDialog(dialog);
                            }
                        }
                    }
                },
                [
                    contentRender,
                    options.confirmText ? createElement('span', { slot: 'confirm-text' }, options.confirmText) : '',
                    options.cancelText ? createElement('span', { slot: 'cancel-text' }, options.cancelText) : '',
                    titleRender,
                    footerRender,
                    options.additionalFooterRender ? createElement('div', { slot: 'additional-footer' }, [options.additionalFooterRender(createElement)]) : ''
                ]
            );
        }
    });
    // eslint-disable-next-line func-names
    dialog.$remove = function() {
        removeDialog(this);
    };
    // eslint-disable-next-line func-names
    dialog.showButtonLoading = function() {
        this.confirmLoading = true;
    };
    // eslint-disable-next-line func-names
    dialog.hideButtonLoading = function() {
        this.confirmLoading = false;
    };

    return dialog;
}

export function setMaxWidthDialog(dialog, width) {
    const $container = dialog.$el && dialog.$el.querySelector && dialog.$el.querySelector('.v-dialog__container');

    if ($container) {
        $container.style.maxWidth = `${width}px`;
    }
}

export function addDialogClass(dialog, className) {
    const $dialog = dialog && dialog.$el;

    operateClass?.addClass($dialog, className);
}


export function hideCloseBtn(dialog) {
    const $close = dialog.$el && dialog.$el.querySelector && dialog.$el.querySelector('.v-dialog__close');

    if ($close) {
        $close.style.display = 'none';
    }
}